import { components } from "@certn/legacy-api/generated-schemas/people";

import { CredentialInputField } from "./CredentialInputField";
import { CredentialsSummaryField } from "./CredentialsSummaryField";
import { FieldType } from "../types";

export function CredentialField(
  field: components["schemas"]["CredentialsCheckField"]
): FieldType<components["schemas"]["CredentialsCheckField"]> {
  return {
    field,
    inputElement: <CredentialInputField key={field.name} field={field} />,
    summaryElement: () => (
      <CredentialsSummaryField key={field.name} field={field} />
    ),
    initialValue: field.value,
  };
}
